import { A } from "@solidjs/router";
import { VENDORS, type VendorKey } from "~/components/landing/compareData";

/**
 * A card linking a post to the comparison with one vendor. MDX isn't typechecked, so an
 * unknown vendor throws while the page renders and fails the prerender instead of shipping
 * a card that names nobody.
 */
export function CompareCallout(props: { vendor: VendorKey }) {
  const vendor = VENDORS.find((v) => v.key === props.vendor);
  if (!vendor) throw new Error(`CompareCallout: unknown vendor "${props.vendor}"`);
  return (
    <A
      href={`/alternatives/${vendor.key}`}
      class="blog-card-link my-8 flex items-center justify-between gap-4 rounded-xl border border-primary-border bg-panel px-5 py-4 no-underline transition-colors hover:border-brand"
    >
      <span class="flex flex-col gap-1">
        <span class="text-xs font-bold tracking-wider text-secondary-text uppercase">Comparing tools?</span>
        <span class="text-base font-semibold text-primary-text">
          See how Chief compares with {vendor.name}, side by side
        </span>
      </span>
      <span aria-hidden="true" class="shrink-0 text-sm font-semibold text-primary-text">
        →
      </span>
    </A>
  );
}
